(function() {
  function init(root) {
    root = root || document;

    var btn = document.getElementById('tw-back-to-top');
    if (btn && !btn.dataset.twFooterBound) {
      btn.dataset.twFooterBound = '1';
      function toggle() {
        var visible = window.scrollY > 400;
        btn.classList.toggle('tw-opacity-100', visible);
        btn.classList.toggle('tw-pointer-events-auto', visible);
      }
      window.addEventListener('scroll', toggle, { passive: true });
      toggle();
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    root.querySelectorAll('.tw-footer__heading').forEach(function(heading) {
      if (heading.dataset.twFooterBound) return;
      heading.dataset.twFooterBound = '1';
      heading.addEventListener('click', function() {
        if (window.innerWidth >= 768) return;
        var block = this.closest('.tw-footer__block');
        if (!block) return;
        block.classList.toggle('is-active');
      });
    });

    root.querySelectorAll('#FooterCountryForm select[data-submit], #FooterLanguageForm select[data-submit]').forEach(function(el) {
      if (el.dataset.twFooterBound) return;
      el.dataset.twFooterBound = '1';
      el.addEventListener('change', function() {
        if (this.form) this.form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
